import { z } from "zod";
import { NOTES_TABLES } from "../../../types/notes";

export const postForeignNotesSchema = z.object({
	notesTable: z.enum(NOTES_TABLES),
	identifier: z.string().uuid(),
});
